<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="19"
         :fill="fill"
         viewBox="0 0 12 19">
        <defs>
            <path id="b4qqa" d="M1258.94 20a.6.6 0 0 0-.6.6v4.74a.6.6 0 0 0 1.2 0V20.6a.6.6 0 0 0-.6-.59z"/>
            <path id="b4qqb" d="M1260.13 34.85a.6.6 0 1 1 1.18 0 .6.6 0 0 1-1.18 0z"/>
            <path id="b4qqc" d="M1256.56 30.1a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0z"/>
            <path id="b4qqd"
                  d="M1260.72 36.63a1.78 1.78 0 1 1 0-3.57 1.78 1.78 0 0 1 0 3.57zm-4.75 0a.6.6 0 0 1-.46-.98l5.94-7.12a.6.6 0 0 1 .91.76l-5.94 7.13a.6.6 0 0 1-.45.2zm1.19-8.32a1.78 1.78 0 1 1 0 3.57 1.78 1.78 0 0 1 0-3.57zm4.4-5.93h-.84v2.96a1.78 1.78 0 0 1-3.56 0v-2.96h-.84l-3.32 3.31v12.13c0 .65.53 1.18 1.19 1.18h9.5c.66 0 1.19-.53 1.19-1.18V25.69z"/>
        </defs>
        <g>
            <g transform="translate(-1253 -20)">
                <g>
                    <g>
                        <g>
                            <use xlink:href="#b4qqa"/>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <use xlink:href="#b4qqb"/>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <use xlink:href="#b4qqc"/>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <use xlink:href="#b4qqd"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "base-discount-icon",
        props: {
          fill: {
              type: String,
              default: '#ffffff'
          }
        },
    }
</script>

<style scoped>

</style>